/* eslint-disable */
/**
 * 移动端适配全局属性（以 Vue 插件形式安装）
 *
 * 设备类型由 App.vue 统一监听 resize 后写入 store（admin/layout），
 * 这里把它挂到 Vue.prototype 上，所有组件模板里可直接用 isMobile。
 *
 * 用 prototype getter 而不是 Vue.mixin，是为了避免给每个组件实例
 * （包括表格里成百上千个单元格组件）都创建一份计算属性 watcher。
 *
 * 组件里可直接使用：
 *   isMobile             是否手机端布局
 *   mobileModalWidth     手机端弹窗宽度（PC 端为 undefined，保持原宽度）
 *   mobileLabelPosition  表单 label 位置
 *   mobileLabelWidth     表单 label 宽度
 *
 * 注意：组件自身定义的同名 data / computed 优先级更高，会遮蔽这里的属性。
 */
function defineGetter(Vue, name, getter) {
    // 组件已自行定义同名属性时不覆盖
    if (Object.prototype.hasOwnProperty.call(Vue.prototype, name)) return;
    Object.defineProperty(Vue.prototype, name, {
        get: getter,
        configurable: true,
    });
}

export default {
    install(Vue) {
        defineGetter(Vue, 'isMobile', function () {
            const admin = this.$store && this.$store.state && this.$store.state.admin;
            return !!(admin && admin.layout && admin.layout.isMobile);
        });
        defineGetter(Vue, 'mobileModalWidth', function () {
            return this.isMobile ? '96%' : undefined;
        });
        defineGetter(Vue, 'mobileLabelPosition', function () {
            return this.isMobile ? 'top' : 'right';
        });
        defineGetter(Vue, 'mobileLabelWidth', function () {
            return this.isMobile ? undefined : 100;
        });
    },
};
